import React, { useEffect } from 'react';
import { CheckoutFoundsOut } from '@components';
import { useFundsOut } from '@hooks';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import * as Routes from '@constants/routes';

const FoundsOutCheck = () => {
  const { amountWithraw } = useSelector((state) => state.andes);
  const { withdraw, getDayLimit } = useFundsOut();
  const handleWithdraw = () => {
    withdraw(amountWithraw, getDayLimit());
  };

  const history = useHistory();

  useEffect(() => {
    if (amountWithraw === null || amountWithraw === 0) {
      history.push(Routes.DO_FUNDS_OUT);
    }
  }, []);

  return (
    <div>
      <CheckoutFoundsOut handleWithdraw={handleWithdraw} amountToShow={amountWithraw} />
    </div>
  );
};

export default FoundsOutCheck;
